import ActionTypes from '../actionTypes/actionTypes';

export const setView = (view, params) => ({
    type: ActionTypes.SET_VIEW,
    view,
    params
});
